import * as Turbo from "@hotwired/turbo";
import * as ActiveStorage from "@rails/activestorage";
import "trix";
import "@rails/actiontext";
import "bootstrap";
import Turbolinks from "turbolinks";
import "../controllers/index"

// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log("Vite ⚡️ Rails");

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log(
  "Visit the guide for more information: ",
  "https://vite-ruby.netlify.app/guide/rails"
);

Turbo.start();
ActiveStorage.start();
Turbolinks.start();
